import {useOrderDataStore} from "@/stores/orderDataStore";

export const getCourierData = async () => {
    try {

        const apiUrl = `${process.env.VUE_APP_API_URL}/rma/courier?country=${useOrderDataStore().shippingCountry}`;
        console.log(apiUrl)
        console.log(useOrderDataStore().shippingCountry)
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        const response = await fetch(apiUrl, requestOptions);
        console.log(response)

        if (!response.ok) {
            throw new Error(`${response.statusText}`);
        }

        return await response.json(); // Return API response

    } catch (error) {
        console.error("Error sending order data:", error);
        throw error;
    }
};